// Recovered compiled webpack factory 65444. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      onCaughtError: function () {
        return c;
      },
      onUncaughtError: function () {
        return f;
      },
    }));
  let n = r(28140),
    a = r(5829),
    o = r(24553),
    i = r(3463),
    s = r(88785),
    l = n._(r(57150)),
    u = {
      decorateDevError: (e) => e,
      handleClientError: () => {},
      originConsoleError: console.error.bind(console),
    };
  function c(e, t) {
    var r;
    let n,
      i = null == (r = t.errorBoundary) ? void 0 : r.constructor;
    if (
      (n =
        n || (i === s.ErrorBoundaryHandler && t.errorBoundary.props.errorComponent === l.default))
    )
      return f(e);
    (0, o.isBailoutToCSRError)(e) || (0, a.isNextRouterError)(e) || u.originConsoleError(e);
  }
  function f(e) {
    (0, o.isBailoutToCSRError)(e) || (0, a.isNextRouterError)(e) || (0, i.reportGlobalError)(e);
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
